/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownRightIcon16Regular = forwardRef('ArrowDCornerDownRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.75 7c0 .69.56 1.25 1.25 1.25h7.94L8.72 5.03a.75.75 0 0 1 1.06-1.06l3.652 3.651a1.95 1.95 0 0 1 0 2.758L9.78 14.03a.75.75 0 0 1-1.06-1.06l3.22-3.22H4A2.75 2.75 0 0 1 1.25 7V.75a.75.75 0 0 1 1.5 0V7Z" })));
});
